import React from 'react';
import { GenerationResult } from 'src/api/interfaces';
import { Box } from '@amzn/awsui-components-core';

export const BASEBALL_ADMIN_AVATAR_RESULTS_COLUMNS = [
  {
    id: 'name',
    header: 'Employee Name',
    cell: (item: GenerationResult) => item.name,
    sortingField: 'name'
  },
  {
    id: 'login',
    header: 'Login',
    cell: (item: GenerationResult) => item.login,
    sortingField: 'login'
  },
  {
    id: 'status',
    header: 'Status',
    cell: (item: GenerationResult) => (
      <Box color={item.status === 'success' ? 'text-status-success' : 'text-status-error'}>{item.status.toUpperCase()}</Box>
    )
  },
  {
    id: 'error',
    header: 'Error',
    cell: (item: GenerationResult) => item.error || '-'
  }
];
